export default {
  dashboardData: (state) => state.dashboardData,
  dashboardLoading: (state) => state.dashboardLoading,
  dashboardError: (state) => state.dashboardError,
  getSellerTicketCount(state) {
    return state.sellerTicketCount;
  },
  getN11TicketCount(state) {
    return state.n11TicketCount;
  },
  getSellerShop(state) {
    return state.SELLER_SHOP;
  },
};
